import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { ChangelogPublicItem } from '../../application/types';

type ChangelogEnvelope = {
  data?: {
    list?: ChangelogPublicItem[];
  };
};

export async function fetchPublishedChangelog(): Promise<ChangelogPublicItem[]> {
  const response = await createPublicClient().get<ChangelogEnvelope>('/changelog');
  return response.data?.data?.list ?? [];
}
